import { useEffect, useMemo, useState } from "react";
import { Session } from "ezStore";
import { CustomDialog } from "components/dialogs/Dialogs";
import { intl } from "LocaleWrapper";
import { Button, FormGroup } from "@cofano/cck";
import Grid from "@mui/material/Grid2";
import StatusChangeSelect from "view/customerUpdate/components/status/StatusChangeSelect";
import { StatusChangeFragmentFragment as StatusChangeFragment } from "__generated__/view/statuses/graphql/fragments.generated";

type StatusChangerDialogProps = {
	open: boolean;
	onClose: () => void;
	statusChanges: StatusChangeFragment[];
	selectedStatusChange?: StatusChangeFragment;
	session: Session;
	onStatusChange: (statusChange: StatusChangeFragment) => void;
}

const CustomerUpdateStatusChangerDialog = ({ open, onClose, statusChanges, selectedStatusChange, session, onStatusChange }: StatusChangerDialogProps) => {

	const [ value, setValue ] = useState<StatusChangeFragment | undefined>(selectedStatusChange);

	const options = useMemo(() => {
		if (!selectedStatusChange) {
			return statusChanges;
		}

		const exists = statusChanges.some(s => s.id === selectedStatusChange.id);
		return exists ? statusChanges : [ selectedStatusChange, ...statusChanges ];
	}, [ statusChanges, selectedStatusChange ]);

	useEffect(() => {
		if (!open) {
			return;
		}
		setValue(selectedStatusChange);
	}, [ open ]);

	const canSubmit = value != null;

	return (
		<CustomDialog
			open={open}
			onClose={onClose}
			maxWidth="xs"
			title={intl.formatMessage({ id: "STATUS" })}
			actions={
				<Button
					onClick={() => {
						if (!value) {
							return;
						}
						onStatusChange(value);
						onClose();
					}}
					disabled={!canSubmit}
					size="small"
				>
					{intl.formatMessage({ id: "CHANGE_STATUS" })}
				</Button>
			}
		>
			<Grid size={12}>
				<FormGroup
					labelPlacement="top"
					label={intl.formatMessage({ id: "NEW_STATUS" })}
					overflow="hidden"
				>
					<StatusChangeSelect
						value={value}
						onChange={(val) => setValue(val ?? undefined)}
						statusChanges={options}
						session={session}
					/>
				</FormGroup>
			</Grid>
		</CustomDialog>
	);
};

export default CustomerUpdateStatusChangerDialog;
